import { getRegion } from './Region';

export const getAddonHeader = (assets, node) => {
  const addonHeaderImg =
    assets[`${getRegion()}_${node?.code}_homeAddon_header_img`] ||
    assets[`${node?.code}_homeAddon_header_img`];

  return addonHeaderImg;
};
